import script from "./BrandLogo.vue?vue&type=script&setup=true&lang=ts"
export * from "./BrandLogo.vue?vue&type=script&setup=true&lang=ts"

import "./BrandLogo.vue?vue&type=style&index=0&id=51fbe854&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51fbe854"]])

export default __exports__